import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const removeEmployerRefereeMutation = gql`
  mutation removeEmployerReferee(
    $customerId: String!
    $subjectId: String!
    $userId: String!
    $reason: String!
    $refereeId: String
  ) {
    removeEmployerReferee(
      customerId: $customerId
      subjectId: $subjectId
      userId: $userId
      reason: $reason
      refereeId: $refereeId
    )
  }
`

export type MutationVars = {
  customerId: string
  subjectId: string
  userId: string
  reason: string
  refereeId: string
}

export type RemoveEmployerRefereeData = {
  removeEmployerReferee: string | unknown
}

export const useRemoveEmployerRefereeMutation: WrappedMutation<
  RemoveEmployerRefereeData,
  MutationVars
> = () =>
  useMutation<RemoveEmployerRefereeData, MutationVars>(removeEmployerRefereeMutation, {
    client: agentClient,
  })
